// extracted by mini-css-extract-plugin
export default {"header":"NavigationList_header__BaJ2L","content":"NavigationList_content__dTGxq"};